import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BranchState {
  /** null = All branches */
  branchId: string | null;
  branchName: string;
  setBranch: (id: string | null, name: string) => void;
}

export const useBranchStore = create<BranchState>()(
  persist(
    (set) => ({
      branchId: null,
      branchName: 'All branches',
      setBranch: (branchId, branchName) => set({ branchId, branchName }),
    }),
    { name: 'omniretail-branch' }
  )
);
